<template>
  <el-dialog
    v-model="resultDialog"
    class="custom-dialog rst-dialog"
    width="800px"
    top="5vh"
    :append-to-body="true"
    :close-on-click-modal="false"
    @closed="onDialogClosed"
  >
    <div>
      <h3>查看结果</h3>
      <p class="info-text">{{ detailInfo ? detailInfo.fileOriginName : '' }}</p>
      <span class="seat-line"></span>
      <div>
        <div class="rst_flex rst_top">
          <img src="@/assets/img/result01@2x.png" class="rst_img" />
          <label class="rst_label">报关类型：</label>
          <span class="rst_span">{{ getFileTypeStr(detailInfo ? detailInfo.type : '') }}</span>
        </div>
        <div class="rst_flex">
          <div class="rst_flex rst_spe">
            <img src="@/assets/img/result02@2x.png" class="rst_img">
            <label class="rst_label">数据形式：</label>
            <span class="rst_span">{{ !isDraft ? '数据库表格' : '报关单草单' }}</span>
          </div>
          <div class="rst_flex">
            <img src="@/assets/img/result03@2x.png" class="rst_img">
            <label class="rst_label">上传结果：</label>
            <span class="rst_span">成功新增{{ detailInfo ? detailInfo.success : 0 }}{{ isDraft ? '个文件' : '条' }}，重复上传{{ detailInfo ? detailInfo.repeat : 0 }}{{ isDraft ? '个文件' : '条' }}，<em>异常{{ detailInfo ? detailInfo.abnormal : 0 }}{{ isDraft ? '个文件' : '条' }}</em></span>
          </div>
        </div>
      </div>
      <div class="list-tab-box">
        <el-tabs v-model="activeName" class="custom_tabs" @tab-click="handleClick">
          <el-tab-pane label="异常数据" name="first">
            <CommonTable class="list-tab" :table-data="abnormals" :columns="columns" :options="options"></CommonTable>
          </el-tab-pane>
          <el-tab-pane label="重复上传数据" name="second">
            <CommonTable class="list-tab" :table-data="repeats" :columns="columns" :options="options"></CommonTable>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="footer">
        <el-button round @click="onCancelClick">取消</el-button>
        <el-button round type="primary" @click="onExoportClick">导出</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import request from '@/request'
import download from '@/request/download'
// import { ElMessage } from 'element-plus'
import CommonTable from '@/components/CommonTable/index.vue'
import variables from '@/styles/variables.module.scss'

export default {
  components: {
    CommonTable
  },
  data() {
    return {
      resultDialog: false,
      activeName: 'first',
      defaultColumns: [
        {
          label: '行号',
          width: '96',
          render: (h, row) => h('span', {
            style: {
              paddingLeft: '40px'
            }
          }, row.row)
        },
        {
          label: '运单号',
          width: '328',
          prop: 'trackingNumber'
        },
        {
          label: '原因描述',
          prop: 'desc'
        }
      ],
      options: {
        index: false,
        size: 'large',
        stripe: false,
        align: 'left',
        multipleRowSelect: false,
        commonStyle: {},
        headStyle: {
          background: variables.rowBg
        },
        rowStyle: this.tableRowStule,
        selectionChange: this.selectionChange,
        height: '100%'
      },
      detailId: '',
      detailInfo: null
    }
  },
  // watch: {
  //   '$root.isuploadDialog': {
  //     deep: true,
  //     handler: function(val) {
  //       if (val) {
  //         this.uploadDialog = val
  //       }
  //     }
  //   }
  // },
  computed: {
    abnormals: {
      get() {
        if (!this.detailInfo) return []
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          if (!this.detailInfo.logFileDetailList) return []
          return this.detailInfo.logFileDetailList.filter(item => !item.isRepeat)
        } else {
          if (!this.detailInfo.logDetailList) return []
          return this.detailInfo.logDetailList.filter(item => !item.isRepeat)
        }
      }
    },
    repeats: {
      get() {
        if (!this.detailInfo) return []
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          if (!this.detailInfo.logFileDetailList) return []
          return this.detailInfo.logFileDetailList.filter(item => item.isRepeat)
        } else {
          if (!this.detailInfo.logDetailList) return []
          return this.detailInfo.logDetailList.filter(item => item.isRepeat)
        }
      }
    },
    isDraft: {
      get() {
        if (!this.detailInfo) return false
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          return true
        }
        return false
      }
    },
    columns: {
      get() {
        if (!this.detailInfo) return this.defaultColumns
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          return [
            {
              label: '序号',
              width: '96',
              render: (h, row) => h('span', {
                style: {
                  paddingLeft: '40px'
                }
              }, row.row)
            },
            {
              label: '文件名',
              width: '328',
              prop: 'fileName'
            },
            {
              label: '原因描述',
              prop: 'desc'
            }
          ]
        } else {
          return this.defaultColumns
        }
      }
    }
  },
  methods: {
    selectionChange() {},
    show(fid) {
      this.detailId = fid
      this.httpGetDetail()
      this.resultDialog = true
    },
    onDialogClosed() {},
    onCancelClick() {
      this.resultDialog = false
    },
    onExoportClick() {
      download({
        url: '/api/v1/upload/download/desc',
        method: 'GET',
        params: {
          id: this.detailId
        }
      }, { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'fileType': '' }).then(res => {
      })
    },
    httpGetDetail() {
      request({
        url: '/api/v1/upload/query/log/history/detail/' + this.detailId,
        method: 'GET',
        params: {
          pageNo: 1,
          pageSize: 100000
        }
      }).then((res) => {
        this.detailInfo = res
      })
    },
    getFileTypeStr(type) {
      if (!type || type.length === 0) return ''
      if (type === 'OB') return '个人物品申报(B类)出口报关'
      if (type === 'OC') return '低价商品出口报关'
      if (type === 'OD') return '正式申报类货物(D类)出口报关'
      if (type === 'IB') return '个人物品申报(B类)进口报关'
      if (type === 'IC') return '低价商品进口报关'
      if (type === 'ID') return '正式申报类货物(D类)进口报关'
      return ''
    },
    handleClick() {}
  }
}
</script>

<style lang="scss">
@import '@/styles/custom-dialog';
@import "@/styles/variables.module.scss";
@import '@/styles/common';

.rst-dialog {
  h3 {
    font-size: 24px;
    color: #080808;
    font-weight: bold;
  }
  .info-text {
    padding: 32px 0 16px;
    font-size: 20px;
    color: #080808;
    font-weight: bold;
  }
  .seat-line {
    width: 32px;
    height: 4px;
    background: #FFD033;
    display: inline-block;
  }
  .rst_img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .rst_flex {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  .rst_label {
    color: #757575;
  }
  .rst_span {
    color: #363636;
    font-weight: bold;
    em {
      color: #DF2901;
      font-style: normal;
    }
  }
  .rst_top {
    padding: 16px 0 12px;
  }
  .rst_spe {
    padding-right: 16px;
    border-right: 1px solid #BFB8AF;
    margin-right: 16px;
    height: 12px;
  }
  .list-tab-box {
    .el-table__body-wrapper {
      max-height: 220px;
      overflow-y: auto;
    }
    .list-tab .el-table td {
      padding: 10px 0;
    }
    td .cell {
      color: #363636;
    }
    .el-table th.is-leaf:first-child {
      padding-left: 30px;
    }
    // .el-table th.is-leaf {
    //   font-weight: bold;
    // }
    .custom_tabs .el-tabs__active-bar {
      left: 16px;
      background-image: none;
    }
    .el-tabs__nav {
      line-height: 40px;
    }
    .custom_tabs {
      padding-top: 16px;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    padding: 64px 0 32px;
  }
  .el-button.el-button--mini {
    height: 44px;
    line-height: 44px;
    border-radius: 32px;
    margin-left: 12px;
  }
}
</style>
